/* eslint-disable radix */
/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable  no-new */
/* eslint-disable  prefer-const */
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useOidc, useOidcIdToken } from '@axa-fr/react-oidc';
import { IconButton, MenuItem, ListItemIcon, Divider, Menu, Grid } from '@mui/material';
import Logout from '@mui/icons-material/Logout';
import { closeIconBlack, veolia_header, home_header, home_Icon_hover } from '../../shared/assets/images';
import Notifications from '../../shared/notification-modal';
import { defaultModalOptions, test_email, user1_email } from '../../shared/constantVariable';

import Help from '../help/help';
import Options from '../options';
import Views from '../views';
import Explorer from '../explorer';
import AboutPopup from '../about';
import { clearLogs } from '../../logger';
import '../../styles/header.scss';

import { setStreamDataProp, setHomeBtnClkFlag } from '../userData';
import { autoRemoveFiles, onSave_saveButton } from '../Flow';

const StatusBar = () => {
  const { t } = useTranslation();
  const translateObject = t;
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openOption, setOpenOption] = useState(false);
  const [viewOption, setViewOption] = useState(false);
  const { idTokenPayload } = useOidcIdToken();
  const { logout, isAuthenticated } = useOidc();
  const [explorerOption, setExplorerOption] = useState(false);
  const [expTime, setexpTime] = useState({});
  const [userDetails, setUserDetails] = useState('');
  const [userMail, setUserMail] = useState('');
  const [visibleAbout, setVisibleAbout] = useState(false);
  const [isHoveredHome, setIsHoveredHome] = useState(false);
  const open = Boolean(anchorEl);
  const location = window.location.pathname;
  const restrictPaths = ['/sign-in', '/home', '/forgot-password', '/sign-up', '/reset_pwd', '/recent-files-list', '/preconfig', '/my-projects', '/shared-projects'];

  const navigate = useNavigate();
  const handleConfirm = () => {
    setModalOption(defaultModalOptions);
    setHomeBtnClkFlag(false);
  };

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    if (isAuthenticated) {
      logout();
      setStreamDataProp(); // remove user saved props // added by Abhi for home btn exit 5-Jan-24
    }
    else {
      clearLogs();
      navigate('/sign-in');
    }
  };

  const handleSessionExpiration = () => {
    localStorage.clear();
    sessionStorage.clear();
    setStreamDataProp(); // remove user saved props // added by Abhi for home btn exit 5-Jan-24
    navigate('/sign-in');
  };

  const handlePopup = () => {
    clearLogs(); // remove the files change logs
    setModalOption({
      ...defaultModalOptions,
      visible: true,
      title: 'Warning',
      message: 'Session has expired. please login!',
      yesOrNo: false,
      onNo: () => handleLogout(),    // added by Abhishek for home btn exit on 5-Jan-24
      // onNo: () => handleConfirm(), // commented by Abhi    ''
      closeText: 'Sign In',
    });
  };
  const closeModelOption = () => {
    setModalOption(defaultModalOptions);
  };
  const openModelPopUp = (message, title, type) => {
    setModalOption({
      ...defaultModalOptions,
      visible: true,
      title,
      message,
      yesOrNo: false,
      onNo: () => closeModelOption,
      type
    });
  };
  // Function to set a cookie added by Akhil on 23rd May24
  const setCookie = (name, value, days) => {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + days);

    document.cookie = `${name}=${value}; expires=${expirationDate.toUTCString()}; path=/`;
  };

  useEffect(() => {
    const LoginUser = JSON.parse(localStorage.getItem('LoginUser'));
    if (idTokenPayload && isAuthenticated) {
      let mail_id = idTokenPayload.sub;
      if (mail_id === test_email && (process.env.REACT_APP_ENV === 'dev')) {
        mail_id = user1_email;
      }
      setUserMail(mail_id);
      const userName = mail_id.split('@')[0].toUpperCase().replace(/\./g, ' ');
      setexpTime(idTokenPayload.exp);
      sessionStorage.setItem('expTime', idTokenPayload.exp);
      sessionStorage.setItem('user_email', mail_id);
      sessionStorage.setItem('user_name', userName);
      setUserDetails(userName);
      setCookie('userid', mail_id, 1);

      // let currTime = new Date().getTime().toString();
      // currTime = currTime.substring(0, 10);

      if ('Notification' in window && Notification.permission === 'default') {
        Notification.requestPermission().then((permission) => {
          console.log('Notification permission:', permission);
        });
      }
      let warningShown = false;
      const currTime = Math.floor(Date.now() / 1000);
      const expiryTime = parseInt(idTokenPayload.exp, 10);
      const initialTimeUntilExpiry = (expiryTime - currTime) - 36000;
      // Schedule popup to fire when we're 500 seconds away from expiry
      setTimeout(() => {
        const now = Math.floor(Date.now() / 1000);
        const liveTimeUntilExpiry = (expiryTime - now) - 36000;
        // if (liveTimeUntilExpiry <= 499) {
        //   warningShown = true;
        // }
        // Check if notification already shown in ANY tab
        const alreadyShown = sessionStorage.getItem('sessionWarningShown');
        if (!alreadyShown && liveTimeUntilExpiry <= 500 && liveTimeUntilExpiry > 0) { // for testing 7190
          const minutesLeft = Math.floor(liveTimeUntilExpiry / 60);
          openModelPopUp(
            translateObject('Your session will expire in 10 minutes. Please save your work and login again.'),
            'Warning',
            'warning'
          );
          // ✅ Persist dismissal flag
          // localStorage.setItem('sessionWarningDismissed', true);

          // brower Notification
          if (Notification.permission === 'granted') {
            new Notification(`⚠️ ${translateObject('Session Expiry Warning')}`, {
              body: translateObject('Your session will expire in 10 minutes. Please save your work and login again.'),
              // icon: '/icons/warning-icon.png' // optional icon
              // requireInteraction: true
            });
            // Persist flag so other tabs know it's already shown
            sessionStorage.setItem('sessionWarningShown', 'true');
            if (document.hidden) {
              let originalTitle = document.title;
              let flash = true;
              const flashInterval = setInterval(() => {
                document.title = flash ? '⚠️ Session Expiring!' : originalTitle;
                flash = !flash;
              }, 1000);

              // Stop flashing when tab becomes visible again
              document.addEventListener('visibilitychange', () => {
                if (!document.hidden) {
                  clearInterval(flashInterval);
                  document.title = originalTitle;
                }
              });
            }
          }

          //  warningShown = true;
        }
        //  if(liveTimeUntilExpiry <= 600){
        //   clearTimeout(warningTimeoutId);
        // }
        // 🔔 Show browser notification

      }, (initialTimeUntilExpiry - 500) * 1000);
      setTimeout(() => handlePopup(), (parseInt(idTokenPayload.exp) - parseInt(currTime)) * 1000);
      if (window.location.origin.includes('winflows.watertechs.cn')) {
        const userTrackData_export = {
          'user_id': sessionStorage.getItem('user_name'),
          'email': sessionStorage.getItem('user_email'),
          'country': 'China', // sessionStorage.getItem('country'),
          'session_time': sessionStorage.getItem('expTime'),
          'winflows_url': window.location.origin
        };
        axios({
          method: 'post',
          // Changed to read user tracking endpoint from env configuration.
          url: process.env.REACT_APP_USER_TRACKING_EXPORT_URL,
          headers: {},
          data: JSON.stringify(userTrackData_export)
        }).then((response) => {
          console.log('response');
        }).catch((err) => {
          console.error(err);
        });
      }
      else {
        console.log('global');
        // if (!sessionStorage.getItem('userTracker') && (process.env.REACT_APP_ENV === 'prod')) { //  && (process.env.REACT_APP_ENV === 'dev')
        if ((process.env.REACT_APP_ENV === 'prod')) {

          const userTrackData_export = {
            'user_id': sessionStorage.getItem('user_name'),
            'email': sessionStorage.getItem('user_email'),
            'country': sessionStorage.getItem('country'),
            'session_time': sessionStorage.getItem('expTime'),
            'winflows_url': window.location.origin
          };
          axios({
            method: 'post',
            // Changed to read user tracking endpoint from env configuration.
            url: process.env.REACT_APP_USER_TRACKING_EXPORT_URL,
            headers: {},
            data: JSON.stringify(userTrackData_export)
          }).then((response) => {
            console.log('response');
          }).catch((err) => {
            console.error(err);
          });
        }
      }
    } else if (LoginUser && LoginUser.isAuthenticated) {
      const mail_id = LoginUser.email;
      setUserMail(mail_id);
      const userName = mail_id.split('@')[0].toUpperCase().replace(/\./g, ' ');
      setexpTime(sessionStorage.getItem('expTime'));
      sessionStorage.setItem('user_email', mail_id);
      sessionStorage.setItem('user_name', userName);
      setUserDetails(userName);
      setCookie('userid', mail_id, 1);
      const currentTime = new Date().getTime();
      if (currentTime > parseInt(expTime)) {
        // Handle session expiration, e.g., redirect to login or show a popup
        handleSessionExpiration();
      }
    } else if (window.location.pathname !== '/sign-in') {
      if (restrictPaths.includes(location)) return null;
      navigate('/sign-in');
    }
  }, [idTokenPayload, isAuthenticated, navigate]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const cropUserName = (text) => {
    if (!text) {
      return 'U';
    };
    const intials = text
      .split(' ')
      .map((arr) => arr[0])
      .join('')
      .toUpperCase();
    return intials;
  };

  const handleCloseOption = () => {
    setOpenOption(false);
    setViewOption(false);
    setExplorerOption(false);
  };

  const closeAboutPopup = () => {
    setVisibleAbout(false);
  };

  // creating function to take yes or no of home exit
  const homeExitYes = () => {
    localStorage.setItem('globalExitBtn', 'false');
    setModalOption(defaultModalOptions);
    onSave_saveButton();
  };

  const homeExitNo = () => {
    localStorage.setItem('globalExitBtn', 'false');
    setModalOption(defaultModalOptions);
    autoRemoveFiles();
    navigate('/recent-files-list');
  };

  // to-do by Abhishek for saved file on exit alert on 03-Jan-2024
  const handleHomeBtnExit = () => {
    setHomeBtnClkFlag(true);
    setIsHoveredHome(false);
    // from new logic : Abhi on 2-feb-24

    const globalExitBtn = JSON.parse(localStorage.getItem('globalExitBtn'));
    if (globalExitBtn) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        title: 'Warning',
        message: translateObject('Do you want to save the file ?'),
        yesOrNo: true,
        onNo: () => homeExitNo(),
        onYes: () => homeExitYes(),
        type: 'warning'
      });
    } else {
      navigate('/recent-files-list');
    }

  };

  const getLayout = () => {
    if (restrictPaths.includes(location)) return null;
    return (
      <div className='navbar-menu'>
        <div style={{ backgroundColor: '#FFF', height: '0px' }} />
        <div className='h-100 nav-container background-brand' style={{ height: '56px' }}>
          <div className='h-100'>
            <Grid container className='h-100 header-container' >
              <Grid className='h-100 header-image' item xs={8} sm={6}>
                <img className='h-100' align="left" src={veolia_header} alt="veolia"
                  style={{ marginLeft: '48px', height: '40px', marginTop: '5px', marginBottom: '5px' }} />
              </Grid>
              <Grid item xs={4} sm={6} className="h-100 recent-file-links sansW4SeLig">
                <ul id="navbar" style={{ marginRight: '48px' }}>
                  <li>
                    <span className="top-navbar" style={{ marginRight: '32px' }} onClick={handleHomeBtnExit}>
                      <img style={{ marginTop: '-4px' }} src={isHoveredHome ? home_Icon_hover : home_header} alt="home"
                        onMouseEnter={() => setIsHoveredHome(true)}
                        onMouseLeave={() => setIsHoveredHome(false)}
                      />
                    </span>
                  </li>
                  <li className='menu-help-wrapper L_Regular' style={{ marginRight: '32px' }}>
                    <Help translateObject={translateObject} />
                  </li>
                  <li>
                    <div className="user-img float-r sansW4SeLig">
                      <IconButton style={{ border: 'none' }} onClick={handleClick} sx={{ p: 0 }}>
                        <span className="sansW4SeLig">
                          {cropUserName(userDetails)}
                        </span>
                      </IconButton>
                    </div>
                  </li>
                </ul>
              </Grid>
              <Menu
                className="header-mui-popup sansW4SeLig"
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: 1.5,
                    '& .MuiAvatar-root': {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    '&:before': {
                      content: '""',
                      display: 'block',
                      position: 'absolute',
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: 'background.paper',
                      transform: 'translateY(-50%) rotate(45deg)',
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
                <div className="user-account-menu">
                  <MenuItem className="user-image-list">
                    <div className="user-account-img">
                      {/* <Avatar /> */}
                      <IconButton sx={{ p: 0 }}>
                        <span className="sansW4SeLig">
                          {cropUserName(userDetails)}
                        </span>
                      </IconButton>
                    </div>
                  </MenuItem>
                  <MenuItem className="d-flex j-center sansW4SeLig">
                    {userDetails}
                  </MenuItem>
                  <MenuItem className="d-flex j-center sansW4SeLig">
                    {userMail}
                  </MenuItem>
                  <Divider />
                  <MenuItem onClick={handleLogout} className="sansW4SeLig">
                    <ListItemIcon>
                      <Logout fontSize="small" />
                    </ListItemIcon>
                    {translateObject('Logout')}
                  </MenuItem>
                </div>
              </Menu>
            </Grid>
          </div>
        </div>
        <div className='about-us' id='about-us'>
          <div className='about-us-header' onClick={closeAboutPopup}>
            <img src={closeIconBlack} alt='close' />
          </div>
          <ul>
            <li> <span>DB Version: </span> <span>4.0</span> </li>
            <li> <span>Date: </span> <span>24/02/2023</span> </li>
          </ul>
        </div>
      </div>
    );
  };

  return (
    <>
      <Notifications
        options={modalOption}
        views={modalOption}
        handleClose={() => handleConfirm()}
      />
      {getLayout()}
      {openOption && (
        <Options
          openOption={openOption}
          handleCloseOption={handleCloseOption}
        />
      )}
      {viewOption && (
        <Views
          viewOption={viewOption}
          handleCloseOption={handleCloseOption}
        />
      )}
      {explorerOption && (
        <Explorer
          explorerOption={explorerOption}
          handleCloseOption={handleCloseOption}
        />
      )}
      {visibleAbout && (
        <AboutPopup
          visibleAbout={visibleAbout}
          closeAboutPopup={closeAboutPopup}
          translateObject={translateObject}
        />
      )}
    </>
  );
};
export default StatusBar;
